const PERMISSION_KEY= "core:app_release_notices";
const PAGE_URL = {
    APP_RELEASE_NOTICES_PAGE: "/admin/core/app-release-notices"
}

export {PERMISSION_KEY, PAGE_URL}

